import { Component } from '@angular/core';

@Component({
  selector: 'elm-svg',
  templateUrl: 'svg.html'
})
export class ElmSvgComponent {
}
